/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
//import { ArrayExtensions, ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IProductSpecificationViewProps } from './dlvry-product-specification';

const ProductSpecificationView: React.FC<IProductSpecificationViewProps> = (props) => {
    const {
        ProductSpecification,
        ProductSpecificationTableProps,
        ProductSpecificationTableBodyProps,
        productSpecificationResult,
        ingredients,
        footer
    } = props;

    const classNameBase = 'ms-product-specification';

    if (!productSpecificationResult) {
        return null;
    }

    return (
        <Module {...ProductSpecification}>
            {ingredients}
            <div className={`${classNameBase}__grid`}>
                {productSpecificationResult.map((table: any, index: number) => {
                    if (!table || table.tableData.length === 0) {
                        return null;
                    }

                    const heading = table.heading;

                    return (
                        <div key={heading.props.text.toLowerCase()} className={`${classNameBase}__group`}>
                            {table.heading}
                            {table.subHeader}
                            <Node {...ProductSpecificationTableProps} data-model-version={table.modelVersion}>
                                <Node {...ProductSpecificationTableBodyProps}>{table.tableData}</Node>
                            </Node>
                        </div>
                    );
                })}
            </div>
            {footer}
        </Module>
    );
};

export default ProductSpecificationView;
